<template>
    <ListenerAccountPage />
</template>

<script>
import ListenerAccountPage from './ListenerAccountPage.vue'

export default {
    name: 'listener-account',
    components: {
        ListenerAccountPage
    }
}
</script>
